import React from "react";
import { connect } from 'react-redux';
import {Loading} from "../libs/loading";
import {updatePage} from "../actions/page";
import {Button, Card, Col, List, Progress, Row, Statistic, Tag} from "antd";
import {loadDashboard} from "../actions/dashboard";
import {displayErrors} from "../libs/utils";
import {DateTimeFromNow} from "../components/shared/DateTimeFromNow";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import AccessItem from "../components/permissions/AccessItem";
import moment from "moment";
import {Link} from "react-router-dom";
import WebsiteLauncher from "../components/shared/WebsiteLauncher";
import {IoChatboxEllipsesOutline} from "react-icons/io5";
import QuickFAQ from "../components/shared/FaqBox";

class Dashboard extends React.Component {
    state = {
        loadingDashboard: false,
        data: null,
        faq: []
    };

    componentDidMount() {
        this.props.updatePage('Dashboard', true);

        this.setState({ loadingDashboard: true });

        this.props.loadDashboard((res) => {
            this.setState({ loadingDashboard: false, data: res.data });

            let faq = [
                {
                    "question": "How do I add more IP addresses or domains?",
                    "answer": "You can order additional IP addresses and add more domains at any time. Use Simple mode for automatic US IP allocation and website setup, or switch to Advanced mode for more control over IP locations and configuration."
                },
                {
                    "question": "How do I point my domain to its IP address?",
                    "answer": "Log in to your domain's DNS provider and update its A record to point to the IP address assigned in your Priority Prospect panel. DNS changes may take some time to propagate."
                },
                {
                    "question": "How do I order IP addresses from different locations?",
                    "answer": "Open your IP group and click the 'Add IP Addresses' button. You can then choose from 46 geographic locations and 86+ data centers worldwide, select how many IP addresses you want from each location, and complete your order. Availability and pricing vary by location."
                },
                {
                    "question": "Can I migrate an existing website automatically?",
                    "answer": "Yes! You can automatically migrate an existing website to your hosting account. Learn more: https://support.priorityprospect.com/knowledgebase/article/can-i-migrate-my-website-automatically-to-my-hosting-account"
                },
                {
                    "question": "Can I mix shared and dedicated IP addresses?",
                    "answer": "Yes! You can use both shared and dedicated IP addresses within the same IP group."
                },
                {
                    "question": "Can I use my own web server?",
                    "answer": "Absolutely! You can use your own web server with Priority Prospect IP addresses. Simply add a custom server from the Hosting menu in your panel."
                }
            ];

            if(this.props.user.user.company.domain_count === 0) {
                faq = [
                    {
                        question: 'Do I need to own my domains already?',
                        answer: 'Yes. You need to own the domains you want to host with Priority Prospect.'
                    },
                    {
                        question: 'What\'s included with each website?',
                        answer: 'Each website comes with a dedicated US IP address, a hosting account, a free SSL certificate, and automatic WordPress installation and updates. Everything is configured automatically to make getting started as easy as possible.'
                    },
                    {
                        question: 'Can I choose different IP locations?',
                        answer: 'Yes! Priority Prospect offers IP addresses across 46 geographic locations and 86+ data centers worldwide. Simple mode automatically assigns dedicated US IP addresses, but you can switch to Advanced mode to choose specific locations and customize your IP addresses.'
                    },
                    {
                        question: 'Can I start with just one website?',
                        answer: 'Yes! You can start with just one domain and a dedicated IP address from $2.89/month. As your needs grow, you can order additional IP addresses and host more websites at any time.'
                    }
                ]
            }

            this.setState({ faq: faq })

        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ loadingDashboard: false });
            }
        });
    }

    getGreeting() {
        const hour = new Date().getHours();

        if (hour >= 5 && hour < 12) return "Good morning";
        if (hour >= 12 && hour < 18) return "Good afternoon";

        return "Good evening";
    }

    render() {
        if(this.props.user === null || this.state.data === null) {
            return <div className='text-center'><Loading /></div>;
        }
        return(
            <Row gutter={[16, 16]}>
                <Col xxl={{span: 20, offset: 2}} sm={{span: 24, offset: 0}}>
                    <div style={{lineHeight: 1, padding: '30px 0px'}}>
                        <h2>{this.getGreeting()}, {this.props.user.user.first_name} 👋</h2>
                        <h3 style={{color: '#6b6b6b', fontWeight: 400}}>
                            {this.props.user.user.company.domain_count === 0 ? 'Let\'s get your first website online!' : 'What\'s next for your websites?'}
                        </h3>
                    </div>

                    <Row gutter={[16, 16]}>
                        <Col md={18} xs={24}>
                            <Row gutter={[16, 16]}>
                                <Col span={24}>
                                    {this.props.user.user.panel_mode === 'SIMPLE' ? <WebsiteLauncher history={this.props.history} /> : null}
                                    {this.props.user.user.company.ip_address_count > 0 || this.props.user.user.panel_mode === 'ADVANCED' ?
                                    <AccessItem scopes={['can_view_billing']}>
                                        <Row gutter={[16, 17]} style={{marginBottom: '20px'}}>
                                            <Col xs={24} xl={6}>
                                                <Card size='small'>
                                                    <Statistic
                                                        title={<span>Unpaid Invoices</span>}
                                                        formatter={val => <span style={{fontWeight: 500, fontSize: '32px'}}>{val}</span>}
                                                        value={this.state.data.unpaid_invoices} />
                                                    <small><Link to='/billing/invoices'>View Invoices</Link></small>
                                                </Card>
                                            </Col>
                                            <Col xs={24} xl={6}>
                                                <Card size='small'>
                                                    <Statistic title='Overdue Invoices'
                                                               formatter={val => <span style={{fontWeight: 500, fontSize: '32px'}}>{val}</span>}
                                                               suffix={this.state.data.overdue_invoices > 0 ?
                                                                   <ExclamationCircleOutlined style={{color: 'red'}}/> : null}
                                                               value={this.state.data.overdue_invoices}/>
                                                    <small><Link to='/billing/invoices'>View Invoices</Link></small>
                                                </Card>
                                            </Col>
                                            <Col xs={24} xl={6}>
                                                <Card size='small'>
                                                    <Statistic title='Suspended Orders'
                                                               formatter={val => <span style={{fontWeight: 500, fontSize: '32px'}}>{val}</span>}
                                                               suffix={this.state.data.suspended_orders > 0 ?
                                                                   <ExclamationCircleOutlined style={{color: 'red'}}/> : null}
                                                               value={this.state.data.suspended_orders}/>
                                                    <small><Link to='/billing/orders'>View Orders</Link></small>
                                                </Card>
                                            </Col>
                                            <Col xs={24} xl={6}>
                                                <Card size='small'>
                                                    <Statistic title='Active Orders'
                                                               formatter={val => <span style={{fontWeight: 500, fontSize: '32px'}}>{val}</span>}
                                                               value={this.state.data.active_orders}/>
                                                    <small><Link to='/billing/orders'>View Orders</Link></small>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </AccessItem> : ''}

                                    {this.state.data.active_orders > 0 || this.props.user.user.panel_mode === 'ADVANCED' ? <Card title='Latest News' size='small' extra={<a href='https://priorityprospect.com/blog/' target='_blank' rel='noreferrer noopener'>View all</a>}>
                                        <List
                                            itemLayout="horizontal"
                                            dataSource={this.state.data.news}
                                            size='small'
                                            renderItem={item => {
                                                const postDate = moment(item.date_modified);
                                                const isNew = postDate.isAfter(moment().subtract(1, 'weeks'));

                                                return <List.Item actions={[<small><DateTimeFromNow value={item.date_modified} /></small>]}>
                                                    <List.Item.Meta
                                                        title={<span>{isNew ? <Tag color="success">NEW!</Tag> : ''}<a href={item.link} target='_blank'
                                                                                                                      rel='noopener noreferrer'>{item.title}</a></span>}
                                                        description={item.content.replace('\n', ' ').replace(/\s+/g, ' ')}
                                                    />

                                                </List.Item>;
                                            }}
                                        />
                                    </Card> : ''}
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6} xs={24}>
                            <div>
                                {this.props.user.user.panel_mode === 'ADVANCED' ? <Card title='Account Usage' size='small' style={{marginBottom: '20px'}}>
                                    <Row>
                                        <Col span={12} className='text-left'>Domains</Col>
                                        <Col span={12} className='text-right'>
                                            <b>{this.state.data.domain_count} / {this.state.data.website_slots_available}</b>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Progress showInfo={false} percent={(this.state.data.domain_count/this.state.data.website_slots_available)*100} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={12} className='text-left'>IP addresses</Col>
                                        <Col span={12} className='text-right'>
                                            <b>{this.state.data.used_ip_addresses} / {this.state.data.ip_address_count}</b>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Progress showInfo={false} percent={(this.state.data.used_ip_addresses/this.state.data.ip_address_count)*100} />
                                        </Col>
                                    </Row>
                                </Card> : ''}

                                {!this.props.user.user.is_customer ? <QuickFAQ
                                    has_active_orders={this.state.data.active_orders > 0}
                                    ip_address_count={this.state.data.ip_address_count}
                                    domain_count={this.state.data.domain_count}
                                    panel_mode={this.props.user.user.panel_mode}
                                /> : ''}

                                <Card style={{marginTop: '20px', backgroundColor: 'rgba(211, 0, 130, 0.05)'}}>
                                    <h2>Need a hand?</h2>
                                    <p>Our support team is available 24/7 to help you with your questions and issues.</p>
                                    <a href='https://support.priorityprospect.com/tickets/create/step1' target='_blank' rel='noreferrer noopener'>
                                        <Button icon={<IoChatboxEllipsesOutline style={{fontSize: '18px', marginBottom: '-6px', marginRight: '8px'}} />} type='primary' block>Open a Ticket</Button>
                                    </a>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = state => ({
    user: state.auth.user
});

export default connect(mapStateToProps, { updatePage, loadDashboard })(Dashboard);